import React from "react";
import { Select, MenuItem, InputLabel, FormControl } from "@mui/material";

const Country = ({
  countryName,
  handleCountryChange,
  countryList,
  countryId,
}) => {
  return (
    <div>
      <FormControl fullWidth size="small">
        <InputLabel id="demo-simple-select-label">Country</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={countryName}
          label="Country"
          onChange={handleCountryChange}
        >
          <MenuItem value="">None</MenuItem>
          {countryList?.map((el) => (
            <MenuItem key={el?.id} value={`${el.country}`}>
              {el.country}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default Country;
